import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom"; // Import useNavigate hook
import { getSubGallery } from "../Service/Api";
import LazyLoad from "react-lazyload";
const SubGallery = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");
  const [data, setData] = useState("");
  const [index, setIndex] = React.useState(-1);

  useEffect(() => {
    const getData = async () => {
      try {
        let subgalleryData = await getSubGallery(id);
        console.log(subgalleryData);
        setData(subgalleryData);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, []);

  const slides = data?.attachments?.map((img) => ({
    src: `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`,
  }));
  return (
    <>
      <div className="breadcrumb">
        <h2>{data.title}</h2>
        <ul>
          <li>
            <Link to="/">
              {" "}
              Home <i className="fas fa-angle-right"></i>{" "}
            </Link>
          </li>
          <li>|</li>
          <li>Photo Gallery</li>
        </ul>
      </div>
      <div className="innerpage">
        <div className="container">
          <div class="row tabs-dynamic mb-4">
            <div class="col-lg-3 col-md-6">
              <p>
                Last Update :{" "}
                <span>
                  {" "}
                  {new Date(data.date).toLocaleDateString("en-GB")}
                </span>{" "}
              </p>
            </div>
            <div class="col-lg-3 col-md-6">
              <p>
                Event Date :{" "}
                <span>
                  {" "}
                  {new Date(data.date).toLocaleDateString("en-GB")}
                </span>{" "}
              </p>
            </div>
            <div class="col-lg-3 col-md-6">
              <p>
                No. of Photos :<span> {data?.attachments?.length}</span>
              </p>
            </div>
            <div class="col-lg-3 col-md-6">
              <p>
                <Link to="/photoGallery">
                  <i class="fa fa-angle-double-left" aria-hidden="true"></i>{" "}
                  Click here to Go Back{" "}
                </Link>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <p>{data.description}</p>
            </div>
          </div>
          <div class="row">
            {" "}
            {data !== "" &&
              data?.attachments.map((img, index) => (
                <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                  <LazyLoad>
                    {" "}
                    <a
                      data-magnify="gallery"
                      data-src=""
                      data-group="a"
                      href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                    >
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                        class="img-fluid"
                        alt=""
                      />
                    </a>
                  </LazyLoad>
                </div>
              ))}
            {/* <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                     <a data-magnify="gallery" data-src="" data-group="a" href="images/common-img-1.jpg"><img src="images/common-img-1.jpg" class="img-fluid" alt="" /></a>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                     <a data-magnify="gallery" data-src="" data-group="a" href="images/common-img-1.jpg"><img src="images/common-img-1.jpg" class="img-fluid" alt="" /></a>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                     <a data-magnify="gallery" data-src="" data-group="a" href="images/common-img-1.jpg"><img src="images/common-img-1.jpg" class="img-fluid" alt="" /></a>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                     <a data-magnify="gallery" data-src="" data-group="a" href="images/common-img-1.jpg"><img src="images/common-img-1.jpg" class="img-fluid" alt="" /></a>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                     <a data-magnify="gallery" data-src="" data-group="a" href="images/common-img-1.jpg"><img src="images/common-img-1.jpg" class="img-fluid" alt="" /></a>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
                     <a data-magnify="gallery" data-src="" data-group="a" href="images/common-img-1.jpg"><img src="images/common-img-1.jpg" class="img-fluid" alt="" /></a>
                  </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubGallery;
